/**
 * @desc 生成任务编号
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.createTask.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/createTask`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
